import CloseIcon from '@mui/icons-material/Close';
import { Modal, Box, Typography, Button } from '@mui/material';
import { colors } from 'src/styles/theme';

const modalStyle = {
  position: 'absolute',
  display: 'flex',
  flexDirection: 'column',
  top: '50%',
  left: '50%',
  cursor: 'pointer',
  transform: 'translate(-50%, -50%)',
  bgcolor: colors.white,
  border: `2px solid ${colors.warning.main}`,
  borderRadius: '10px',
  boxShadow: 24,
  p: 4,
  maxHeight: '90%',
  overflow: 'auto',
  mb: '1rem',
  width: {
    lg: '40%',
    md: '65%',
    sm: '80%',
    xs: '95%',
  },
};

const WarningModal = ({ secondsLeft, closeModal, open, onRefreshClick }) => {
  return (
    <Modal open={open} onClose={closeModal}>
      <Box sx={modalStyle}>
        <Box sx={{ display: 'flex', justifyContent: 'end', mb: '2rem' }}>
          <CloseIcon
            sx={{
              color: 'grey',
              cursor: 'pointer',
            }}
            onClick={closeModal}
          />
        </Box>
        <Typography variant="h6" sx={{ mb: '1rem', color: colors.warning.dark }}>
          Session Warning
        </Typography>
        <Typography variant="body1">
          Your session will expire in {secondsLeft} seconds. Would you like to extend it?
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: '2rem' }}>
          <Button data-cy="close" variant="outlined" onClick={closeModal}>
            Dismiss
          </Button>
          <Button data-cy="refresh" color="primary" variant="contained" onClick={onRefreshClick}>
            Extend Session
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default WarningModal;
